import logoImage from "@/assets/images/android-chrome-512x512.png";
import faviconIco from "@/assets/images/favicon.ico";
//import faviconSvg from "@/assets/images/favicon.svg";
import favicon16 from "@/assets/images/favicon-16x16.png";
import favicon32 from "@/assets/images/favicon-32x32.png";
import appleTouchIcon from "@/assets/images/apple-touch-icon.png";
import pwa192 from "@/assets/images/android-chrome-192x192.png";
import pwa512 from "@/assets/images/android-chrome-512x512.png";

export const ASSETS = {
  LOGO: logoImage,
  // Favicons
  FAVICON_ICO: faviconIco,
  //FAVICON_SVG: faviconSvg,
  FAVICON_16: favicon16,
  FAVICON_32: favicon32,
  APPLE_TOUCH_ICON: appleTouchIcon,
  // PWA Icons
  PWA_192: pwa192,
  PWA_512: pwa512,
  // Add other assets here as needed
  // DEFAULT_AVATAR: '/images/default-avatar.png',
} as const;

export type AssetKey = keyof typeof ASSETS;
